import { WebSocketClient, parseURI } from '@cian/chats-api/lib/browser-entry';
import { getConfig } from '@cian/config/browser';
import { ConfigurationError, NotFoundError } from '@cian/peperrors/shared';

let ws: WebSocketClient;

export function initWS() {
  if (ws) {
    return ws;
  }

  const baseWsApi = getConfig().getStrict<string>('chats.baseWsApi');
  const uri = parseURI(`${baseWsApi}v1/endpoint/`);

  if (!uri) {
    throw new ConfigurationError({
      message: `Invalid chats base ws api: ${baseWsApi}`,
      domain: 'initWs',
    });
  }

  ws = new WebSocketClient({
    uri,
  });

  return ws;
}

export function getWS() {
  if (!ws) {
    throw new NotFoundError({
      message: 'WS must be created before accessing it. Forgot to call init() before accessing ws?',
      domain: 'getWs',
    });
  }

  return ws;
}
